import e from"react";var r=function(r){var a=r.divider,i=void 0===a?"/":a;return e.createElement("span",{className:"c-breadcrumb-item-divider","data-testid":"qa-breadcrumb-item-divider","aria-hidden":!0},i)};export{r as BreadcrumbItemDivider};
//# sourceMappingURL=BreadcrumbItemDivider.js.map
